import { useContext } from 'react';

import type { THttpClient } from '../types';
import { HttpClientProviderContext } from '../HttpClientProviderContext';

export const useHttpClient = (): THttpClient => {
  const { httpClient } = useContext(HttpClientProviderContext);

  if (!httpClient) {
    throw new Error('HttpClientProviderContext not found');
  }

  return httpClient;
};
